<template>
  <div>
    <el-row>
      <!--필터링 그룹 버튼-->
      <el-row class="title-bar" type="flex" justify="space-between">
        <div class="vertical-center-box">
          <div class="title-h3 mr-r15">필터링 설정</div>
          <div class="setting-addel">
            <el-button size="mini" @click="showAddLogFilterPopup"><i class="fas fa-plus"></i></el-button>
            <el-button size="mini" @click="deleteLogFileter" :disabled="!checkSelectLog"><i class="fas fa-minus"></i></el-button>
          </div>
        </div>
        <div class="vertical-center-box" align="right">
          <el-button :disabled="!checkSelectLog" @click="showFiltertreeListPopup" type="primary" size="mini">그룹저장</el-button>
        </div>
      </el-row>
      <!--테이블-->
      <el-row>
          <el-table-wrapper :column-default="columnDefault" row-class-name="c-dblclick" border :data="filterTableData" :columns="filterSettingColumn" :pagination="false"
            :show-custom-header="false" @cell-dblclick="showFilterUpdatePopup" highlight-current-row @selection-change="checkFilterSelection" header-align="center" >
          </el-table-wrapper>
      </el-row>
    </el-row>
    <w-app-log-filter-popup ref="appLogFilterPopup" :selectPhysicalNode="selectPhysicalNode" @loadData="loadData" :formData="settingData" :type="type"></w-app-log-filter-popup>
    <w-app-log-tree-list-popup ref="appLogTreeListPopup" :checkList="treeList" :selectPhysicalNode="selectPhysicalNode"></w-app-log-tree-list-popup>
  </div>
</template>

<script>
import ApplogSettingAPI from '@/api/settings/log/app-log-setting';
import isNil from 'lodash/isNil';
import cloneDeep from 'lodash/cloneDeep';
import msgUtil from '@/utils/message';
import { columnDefault } from '@/constants/table';
import WAppLogFilterPopup from '../popup/AppLogFilterPopup';
import WAppLogTreeListPopup from '../popup/AppLogTreeListPopup';

export default {
  name: 'WLogFilteringSetting',
  props: {
    selectPhysicalNode: {
      type: Object,
    },
  },
  data() {
    return {
      columnDefault,
      type: 'Add',
      settingData: {},
      groupValue: '',
      nodeValue: '',
      nodeOptions: [],
      groupOptions: [],
      filterTableData: [],
      checkFilterList: {},
      treeList: [],
      params: {},
      filterSettingColumn: [
        {
          align: 'center',
          headerAlign: 'center',
          type: 'selection',
          width: '50px',
          prop: 'check_flag',
        },
        { prop: 'applogId', label: '로그명' },
        { prop: 'applogFilterId', label: '필터링 명' },
        { prop: 'filterCondition', label: '필터링 조건 정규 표현식' },
        { prop: 'solution', label: '조치방법' },
      ],
      checkSelectLog: false,
      checkPhysicalNode: false,
    };
  },
  watch: {
    checkFilterList() {
      if (Object.values(this.checkFilterList).length > 0) {
        this.checkSelectLog = true;
      } else {
        this.checkSelectLog = false;
      }
    },
    selectPhysicalNode() {
      if (!isNil(this.selectPhysicalNode.serverId)) {
        this.checkPhysicalNode = true;
        this.loadData();
      } else {
        this.checkPhysicalNode = false;
        this.filterTableData = [];
      }
      if (!isNil(this.selectPhysicalNode.serverId)) {
        this.$nextTick(() => {
          this.loadData();
        });
      }
    },
  },
  components: {
    WAppLogFilterPopup,
    WAppLogTreeListPopup,
  },
  methods: {
    /**
     * 필터 테이블 데이터 조회
     * @author leesy918
     * @return {[type]} [description]
     */
    loadData() {
      this.params.serverId = this.selectPhysicalNode.serverId;
      ApplogSettingAPI.getApplogFilterList(this.params).then((response) => {
        if (response.data.success) {
          // 응답 데이터 처리
          this.filterTableData = response.data.data;
        }
      });
    },
    /**
     * 필터 그룹 저장 팝업
     * @author leesy918
     * @return {[type]} [description]
     */
    showFiltertreeListPopup() {
      this.$refs.appLogTreeListPopup.open();
    },
    /**
     * 필터 수정 팝업
     * @author leesy918
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    showFilterUpdatePopup(row) {
      this.type = 'Update';
      this.settingData = cloneDeep(row);
      this.$refs.appLogFilterPopup.open();
    },
    /**
     * 필터 추가 팝업
     * @author leesy918
     * @return {[type]} [description]
     */
    showAddLogFilterPopup() {
      if (isNil(this.selectPhysicalNode.serverId)) {
        this.$message(msgUtil.getRequireInfoMsg(msgUtil.action.SELECT, '서버'));
      } else {
        this.type = 'Add';
        this.settingData = {};
        this.$refs.appLogFilterPopup.open();
      }
    },
    /**
     * 체크박스 값 확인
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    checkFilterSelection(data) {
      this.checkFilterList = data;
      this.treeList = data;
    },
    /**
     * 체크한 필터 삭제
     * @author leesy918
     * @return {[type]} [description]
     */
    deleteLogFileter() {
      this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.DELETE)).then(() => {
        ApplogSettingAPI.deleteApplogFilter(this.checkFilterList).then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '필터', true));

            this.loadData();
          }
        });
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/log/Applog/component/LogFilteringSetting.vue